import { createContext, useContext, useState } from "react";
import axios from "axios";

const AuthContext = createContext();

export const useAuth = () => {
  return useContext(AuthContext);
};

// Restore token synchronously at module load time — before any component renders
const storedToken = localStorage.getItem("token");
if (storedToken) {
  axios.defaults.headers.common["Authorization"] = `Token ${storedToken}`;
}

export const AuthProvider = ({ children }) => {
  // Restore user synchronously via lazy initializer — no useEffect needed
  const [user, setUser] = useState(() =>
    JSON.parse(localStorage.getItem("loggedIn"))
  );

  const login = (userData, token) => {
    setUser(userData);
    localStorage.setItem("loggedIn", JSON.stringify(userData));
    localStorage.setItem("token", token);
    axios.defaults.headers.common["Authorization"] = `Token ${token}`;
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem("loggedIn");
    localStorage.removeItem("token");
    delete axios.defaults.headers.common["Authorization"];
  };

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
